import { useEffect } from "react"

export const CHATWOOT_BASE_URL = "https://suporte.bonifi.ca"
const WEBSITE_TOKEN = "JEHJnttoGKBwRmCuUnijdj4b"

// Limpa o widget e o localStorage do Chatwoot, retornando ao estado inicial.
// Deve ser chamada APÓS o CSAT ser enviado — não antes, senão o formulário não aparece.
export function resetChatwootWidget() {
  if (typeof window.$chatwoot?.reset === "function") {
    window.$chatwoot.reset()
  }
}

export default function useChatwoot() {
  useEffect(() => {
    if (window.chatwootSDK) return

    window.chatwootSettings = {
      position: "left",
      type: "expanded_bubble",
      launcherTitle: "",
      hideMessageBubble: true,
    }

    const script = document.createElement("script")
    script.src = `${CHATWOOT_BASE_URL}/packs/js/sdk.js`
    script.async = true
    script.onload = () => {
      window.chatwootSDK.run({ websiteToken: WEBSITE_TOKEN, baseUrl: CHATWOOT_BASE_URL })
    }

    document.head.appendChild(script)
  }, [])
}
